import ComponentManager from '@/Management/ComponentManager';
import ViewFactory from '@/Factories/ViewFactory';
import WireframeViewModel from '@/ViewModels/Views/WireframeViewModel';
import WireframeView from '@/Views/WireframeView';
import RADApplication from '@/Management/RADApplication';

export default class WireframeViewFactory extends ViewFactory {

    /**
     * @override
     */
    public viewModel: WireframeViewModel;

    constructor(params: any) {
        super(params);
    }

    public getRegion(): string {
        return 'Body';
    }

    /**
     * @override
     */
    public getView(): JQuery {
        if (this.viewModel == null) {
            this.viewModel = this.createViewModel();
        }

        if (this.view == null) {
            this.view = this.createView(this.viewModel);
        }

        const tuple = this.view.getTuple();
        return tuple.view;
    }

    public createViewModel(): WireframeViewModel {
        const wireframeViewModel = ComponentManager.getViewModel<typeof WireframeViewModel>('WireframeViewModel');
        
        return new wireframeViewModel({ viewFactory: this });
    }

    public createView(viewModel: WireframeViewModel): WireframeView {
        const wireframeView = ComponentManager.getView<typeof WireframeView>('WireframeView');
        return new wireframeView(this.viewModel, this.createRootElement('Wireframe'));
    }
}

if (!RADApplication.getInstance().IsReducedView) {
    ComponentManager.setFactory('Wireframe', WireframeViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');
}